import {Component, OnInit, AfterViewInit} from '@angular/core';
import * as Highcharts from 'highcharts';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-high-chart-map',
    templateUrl: './high-chart-map.component.html',
    styleUrl: './high-chart-map.component.scss'
})
export class HighChartMapComponent implements OnInit {
    Highcharts: typeof Highcharts = Highcharts;
    chartConstructor = "mapChart";
    chartData = [{ code3: "ABW", z: 105 }, { code3: "AFG", z: 35530 }];
    chartOptions: Highcharts.Options;
    url: string = '../../../assets/geojsons/regions.json';

    ngOnInit(): void {
        this.drawMap();
    }

    private async drawMap () {
        // Prepare random data
        // const data: any[] = [
        //     ['DE.SH', 728],
        //     ['DE.BE', 710],
        //     ['DE.MV', 963],
        //     ['DE.HB', 541],
        //     ['DE.HH', 622],
        //     ['DE.RP', 866],
        //     ['DE.SL', 398],
        //     ['DE.BY', 785],
        //     ['DE.SN', 223],
        //     ['DE.ST', 605],
        //     ['DE.NW', 237],
        //     ['DE.BW', 157],
        //     ['DE.HE', 134],
        //     ['DE.NI', 136],
        //     ['DE.TH', 704],
        //     ['DE.', 361]
        // ];
        const data: any[] = [
            [25, 728],
            [18, 120],
            [1, 320],
            [7, 453],
            [12, 812],
            [10, 398],
            [9, 194],
            [11, 276],
            [6, 542],
            [17, 328],
            [20, 188],
            [22, 420],
            [3, 523],
            [21, 624],
            [23, 651],
            [16, 614],
            [51, 432],
            [54, 513],
            [53, 541],
            [52, 651],
            [5, 432],
            [8, 129],
            [4, 653],
            [13, 230],
            [2, 298],
            [14, 329],
            [24, 187],
            [55, 654],
            [19, 432],
            [15, 521],
            [26, 425]
        ];

        // Load the geojson germany map
        let geojson = await fetch(this.url).then(response => response.json());

        // geojson = geojson?.features?.map(f=>({
        //   ...f,
        //   properties: {
        //     ...f?.properties,
        //     code_hasc: f?.properties?.Region_Cod
        //   }
        // }))

        this.chartOptions = {
            chart: {
                map: geojson
            },

            title: {
                text: 'Feedbacks Summary By Regions'
            },

            accessibility: {
                typeDescription: 'Map of Germany.'
            },

            mapNavigation: {
                enabled: true,
                buttonOptions: {
                    verticalAlign: 'bottom'
                }
            },

            colorAxis: {
                tickPixelInterval: 100
            },

            credits: {
                enabled: false
            },

            series: [{
                type: 'map',
                keys: ['code_hasc', 'value'],
                joinBy: 'code_hasc',
                name: 'Feedbacks',
                dataLabels: {
                    enabled: true,
                    format: '{point.properties.postal}'
                },
                data: data
            }]
        };

    }
}